/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListConversationsQueryResponse, ListConversationsPathParams, ListConversationsQueryParams, ListConversations401, ListConversations500 } from "../../types/chatController/ListConversations.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listConversations } from "../../client/chatController/listConversations.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listConversationsQueryKey = (organizationId: ListConversationsPathParams["organizationId"] | undefined, params?: ListConversationsQueryParams) => [{ url: '/api/organizations/:organizationId/chat/conversations', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListConversationsQueryKey = ReturnType<typeof listConversationsQueryKey>

export function listConversationsQueryOptions(organizationId: ListConversationsPathParams["organizationId"] | undefined, params?: ListConversationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listConversationsQueryKey(organizationId, params)
        return queryOptions<ListConversationsQueryResponse, ResponseErrorConfig<ListConversations401 | ListConversations500>, ListConversationsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listConversations(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List AI chat conversations
 * {@link /api/organizations/:organizationId/chat/conversations}
 */
export function useListConversations<TData = ListConversationsQueryResponse, TQueryData = ListConversationsQueryResponse, TQueryKey extends QueryKey = ListConversationsQueryKey>(organizationId: ListConversationsPathParams["organizationId"] | undefined, params?: ListConversationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListConversationsQueryResponse, ResponseErrorConfig<ListConversations401 | ListConversations500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listConversationsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listConversationsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListConversations401 | ListConversations500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}